import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { axios, queryClient } from '@apps-common/lib'
import { IAccountNoModel } from '@apps-common/types/management/account-no'

export const QUERY_KEY_MANAGEMENT_GET_ACCOUNT_NOS_INFINITE = (
  id?: string,
  accountNo?: string,
  onlyAvailable?: boolean,
  skip?: number,
  take?: number
) => ['getAccountNos', id, accountNo, onlyAvailable, skip, take].filter(Boolean)

export const getAccountNosInfinite = async (
  id: string,
  accountNo: string,
  onlyAvailable: boolean,
  skip: number,
  take: number
): Promise<IAccountNoModel[]> =>
  axios
    .get(
      `/management/AccountNo/GetAccountNos?mCentreId=${id}&accountNo=${accountNo}&onlyAvailable=${onlyAvailable}&skip=${skip}&take=${take}`
    )
    .then((res) => res.data?.data)

type Props = {
  enabled: boolean
  id: string
  accountNo: string
  onlyAvailable: boolean
  take: number
}

export const useManagementGetAccountNosInfinite = ({ enabled, id, accountNo, onlyAvailable, take }: Props) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage, hasNextPage } = useInfiniteQuery({
    enabled,
    queryKey: QUERY_KEY_MANAGEMENT_GET_ACCOUNT_NOS_INFINITE(id, accountNo, onlyAvailable, take),
    initialPageParam: 0,
    queryFn: ({ pageParam = 0 }) => getAccountNosInfinite(id, accountNo, onlyAvailable, pageParam, take),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.length < take) {
        return null
      }

      return allPages?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
    }
  })

  useEffect(
    () => () => {
      queryClient.removeQueries({ queryKey: QUERY_KEY_MANAGEMENT_GET_ACCOUNT_NOS_INFINITE() })
    },
    []
  )

  return {
    isLoading,
    isFetching,
    isRefetching,
    isError,
    data,
    refetch,
    fetchNextPage,
    hasNextPage
  }
}
